<template>
  <div>
    <statistik :value="statistik"></statistik>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header btn-filter @search="onSearch" @reload="onReload" @filter="onFilter">
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text"> {{ total }} Komite Sekolah</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterStatus"
      />
      <v-card-text class="pa-0">
        <div>
          <base-list-table
            :hideHeader="true"
            :loading="loading"
            :item="data"
            :total="total"
            :usePaging="false"
            @fetch="fetchData"
          >
            <template slot-scope="{ item }">
              <td>
                <v-list-item dense class="px-0">
                  <v-list-item-content>
                    <v-row>
                      <v-col class="py-0" cols="12" md="4">
                        <v-list-item class="px-0">
                          <v-list-item-avatar color="secondary">
                            <v-icon dark>mdi-home</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content class="py-0 my-3">
                            <div class="black--text subtitle-2">
                              {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                            </div>
                            <div class="caption">
                              <span>
                                <v-icon small left>mdi-label-outline</v-icon>
                                {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                              </span>
                              <br />
                              <span>
                                <v-icon small left>mdi-map-marker</v-icon>
                                {{
                                  ($getDeepObj(item, 'sekolah.data.m_kota.data.keterangan') || '-') +
                                    ' - ' +
                                    ($getDeepObj(item, 'sekolah.data.m_propinsi.data.keterangan') || '-')
                                }}
                              </span>
                              <br />
                              <span>
                                <v-icon small left>mdi-city</v-icon>
                                {{ $getDeepObj(item, 'sekolah.data.m_jenjang.data.singkat') || '-' }}
                              </span>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="pt-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption">Kepala Sekolah</span>
                            <p class="ma-0">
                              <span>{{ $getDeepObj(item, 'ptk_kasek.data.nama') || '-' }}</span>
                            </p>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="px-0" v-if="$getDeepObj(item, 'ptk_id_wakasek')">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption">Wakasek Kurikulum SMK</span>
                            <p class="ma-0">
                              <span>{{ $getDeepObj(item, 'ptk_wakasek.data.nama') || '-' }}</span>
                            </p>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption">Pengawas Sekolah</span>
                            <p>
                              <span v-if="$getDeepObj(item, 'psp_diklat_pengawases.data').length">
                                {{ $getDeepObj(item, 'psp_diklat_pengawases.data.0.ptk.data.nama') || '-' }}
                              </span>
                              <span v-else class="error--text">Belum ditentukan</span>
                            </p>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption">Jumlah Guru Diklat</span>
                            <div>
                              <v-chip
                                @click="onListPeserta(item)"
                                small
                                dark
                                :color="Number($getDeepObj(item, 'jml_guru_diklat') || 0) === 0 ? 'grey' : 'info'"
                              >
                                <span style="font-size: 1.3em">
                                  {{ $getDeepObj(item, 'jml_guru_diklat') || 0 }}&nbsp;&nbsp;
                                </span>
                              </v-chip>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content
                            class="py-0 mt-3"
                            v-if="+item.k_ajuan_diklat_psp < 2 && $allow(`${access}.ajuan-sekolah`, item.policies)"
                          >
                            <v-list-item-title>
                              <v-label color="caption"><small>Aksi Selanjutnya</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-btn
                                color="primary"
                                small
                                block
                                @click="onAjuan(item)"
                                :disabled="!isLengkapAjuan(item)"
                              >
                                Ajukan Peserta
                              </v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-content class="py-0 mt-3" v-else>
                            <span class="caption">Status</span>
                            <div>
                              <v-chip small dark :color="color[item.k_ajuan_diklat_psp]">
                                {{ $getDeepObj(item, 'm_ajuan_diklat_psp.data.keterangan') || '-' }}
                              </v-chip>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </v-list-item-action-text>
                </v-list-item>
              </td>
            </template>
          </base-list-table>
        </div>
        <v-card-actions>
          <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" :mode="formulir.mode" generalError :title="formulir.title" @save="onSave">
      <component
        ref="formulir"
        :is="formulir.form"
        :mode="formulir.mode"
        :isChecked="formulir.isChecked"
        :isEdit="formulir.isEdit"
        :initValue="formulir.init"
        :errorEmail="formulir.errorEmail"
        :detail="formulir.detail"
        :meta="formulir.meta"
        :type="type"
        :masters="masters"
      />
    </base-modal-full>
  </div>
</template>
<script>
import mixin from './mixin';
import list from '@mixins/list';
import Statistik from './component/Statistik';
import FormPeserta from './formulir/Peserta';
import FormPengawas from './formulir/Pengawas';
import FormInfo from './formulir/Info';
import { mapState } from 'vuex';
export default {
  mixins: [list, mixin],
  components: {
    Statistik,
    FormPeserta,
    FormPengawas,
    FormInfo,
  },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    access: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formulir: {},
      meta: {},
      color: {
        2: 'info',
        4: 'success',
        5: 'warning',
      },
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    isLengkap() {
      return this.$getDeepObj(this.meta, 'is_lengkap');
    },

    statusLengkap() {
      return this.$getDeepObj(this.meta, 'status_lengkap');
    },

    status() {
      return [
        {
          label: `Daftar Peserta Diklat Sekolah (${this.statusLengkap['jml_lengkap'] || 0}/${this.statusLengkap[
            'jml_sekolah'
          ] || 0})`,
          value: this.isLengkap ? 'passed' : 'not_complete',
        },
      ];
    },

    mJenjang() {
      let temp = {};
      for (const key in this.masters && this.masters['jenjang']) {
        if (Number(key) < 7) temp[key] = this.masters['jenjang'][key];
      }
      return temp;
    },

    mAjuanPsp() {
      let temp = {};
      for (const key in this.masters && this.masters['ajuan_diklat_psp']) {
        if (Number(key) !== 3) temp[key] = this.masters['ajuan_diklat_psp'][key];
      }
      return temp;
    },

    filtersMaster() {
      return {
        k_ajuan_diklat_psp: this.masters && this.masters['ajuan_diklat_psp'],
        k_jenjang: this.mJenjang,
        k_propinsi: this.masters && this.masters['propinsi'],
        k_kota: this.masters && this.masters['kota'],
      };
    },

    formFilter() {
      return [
        {
          label: 'Pilih Jenjang',
          default: true,
          type: 'checkbox',
          row: true,
          model: 'k_jenjang',
          master: this.$mapForMaster(this.mJenjang),
          grid: { cols: 12 },
        },
        {
          label: 'Pilih Status Ajuan',
          default: true,
          type: 'checkbox',
          row: true,
          model: 'k_ajuan_diklat_psp',
          master: this.$mapForMaster(this.mAjuanPsp),
          grid: { cols: 12 },
          size: 3,
        },
      ];
    },
  },

  created() {
    this.getMasters('propinsi;kota;jenjang|value:singkat;ajuan_diklat_psp');
  },

  methods: {
    allow(action, data) {
      const kAjuan = this.$getDeepObj(data, 'k_ajuan_diklat_psp') || 1;
      let disabled = false;

      switch (action.event) {
        case 'onAktif':
          disabled = !Number(this.$getDeepObj(data, 'akun.is_aktif') || 0);
          break;
        case 'onNonAktif':
          disabled = Number(this.$getDeepObj(data, 'akun.is_aktif') || 0);
          break;
        case 'onEditPeserta':
          action.title = `${
            Number(this.$getDeepObj(data, 'jml_guru_diklat') || 0) ? 'Ubah' : 'Pilih'
          } Guru Peserta Diklat`;
          disabled = [1, 5].indexOf(kAjuan) > -1 && this.$allow(action.akses, data.policies);
          break;
        case 'onEditPengawas':
          action.title = this.$getDeepObj(data, 'psp_diklat_pengawases.data').length
            ? 'Ubah Data Pengawas'
            : 'Pilih Pengawas';
          disabled = [1, 5].indexOf(kAjuan) > -1 && this.$allow(action.akses, data.policies);
          break;
        case 'onDeletePengawas':
          disabled = [1, 5].indexOf(kAjuan) > -1 && this.$allow(action.akses, data.policies);
          break;
        case 'onAjuan':
          disabled =
            [1, 5].indexOf(kAjuan) > -1 && this.isLengkapAjuan(data) && this.$allow(action.akses, data.policies);
          break;
        case 'onBatalAjuan':
          disabled = kAjuan === 2 && this.$allow(action.akses, data.policies);
          break;
        default:
          disabled = this.$allow(action.akses, data.policies);
          break;
      }
      return disabled;
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
